import React from "react"
import { Marker } from "react-map-gl"
import { Box } from "@chakra-ui/react"
import { ReactComponent as TripA } from "../assets/images/trip-a.svg"
import { ReactComponent as TripB } from "../assets/images/trip-b.svg"
import { TripEntity } from "../lib/types/trip"
import CircleLayer from "../mapbox/CircleLayer"
import PolylineLayer from "../mapbox/PolylineLayer"
import { useTripsStyle } from "../lib/hooks/useTripsStyle"

interface TripLayerProps {
  trip: TripEntity
  isSelected: boolean
  isHovered: boolean
  beforeId?: string
}

const TripLayerMapbox = React.memo(function TripLayer({
  trip,
  isHovered,
  isSelected,
  beforeId,
}: TripLayerProps) {
  const tripsStyle = useTripsStyle()
  if (!trip.route) return null

  const start = trip?.route?.coordinates[0]
  const end = trip?.route?.coordinates[trip.route.coordinates.length - 1]
  const startCenter = { longitude: start[0], latitude: start[1] }
  const endCenter = { longitude: end[0], latitude: end[1] }

  return (
    <>
      <PolylineLayer
        id={`trip_${trip.uuid}`}
        layout={{ lineJoin: "round" }}
        paint={{
          lineOpacity: isHovered || isSelected ? 1 : tripsStyle.opacity,
          lineColor: isHovered || isSelected ? tripsStyle.color["800"] : tripsStyle.color["500"],
          lineWidth: 5,
        }}
        points={trip.route.coordinates}
        properties={trip}
        addBorder
        borderColor={tripsStyle.color["900"]}
        {...(beforeId ? { beforeId } : {})}
      />
      {isSelected ? (
        <>
          <Marker {...startCenter} anchor="center">
            <Box as={TripA} h="26px" />
          </Marker>
          <Marker {...endCenter} anchor="center">
            <Box as={TripB} h="26px" />
          </Marker>
        </>
      ) : (
        <>
          <CircleLayer
            id={`trip_${trip.uuid}_start`}
            paint={{
              circleOpacity: 0.5,
              circleColor: tripsStyle.color["700"],
            }}
            center={start}
          />
          <CircleLayer
            id={`trip_${trip.uuid}_end`}
            paint={{
              circleOpacity: 0.5,
              circleColor: tripsStyle.color["700"],
            }}
            center={end}
          />
        </>
      )}
    </>
  )
})

export default TripLayerMapbox
